import { IChildrenProps } from '@/types/common.types'
import { memo } from 'react'

const BigContainer = memo(({ children }: IChildrenProps) => {
  return <div className="mx-auto w-full max-w-7xl px-4">{children}</div>
})

export default BigContainer
